import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { formatDate } from "../../../constants/helper";

const TampilHitunganSimulasi = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idHitunganSimulasi } = useParams();
  const [no, setNo] = useState("");
  const [tglLelang, setTglLelang] = useState("");
  const [nominalLelang, setNominalLelang] = useState("");
  const [subsidi, setSubsidi] = useState("");
  const [angsuran, setAngsuran] = useState("");
  const [cadangan, setCadangan] = useState("");
  const [totalPenerimaanLelang, setTotalPenerimaanLelang] = useState("");
  const [lelangUndi, setLelangUndi] = useState("");
  const [sisaPeriode, setSisaPeriode] = useState("");
  const [hutang, setHutang] = useState("");
  const [yangSudahDisetor, setYangSudahDisetor] = useState("");
  const [totalSetor, setTotalSetor] = useState("");
  const [uangYangDiterima, setUangYangDiterima] = useState("");
  const [selisih, setSelisih] = useState("");
  const [bunga, setBunga] = useState("");
  const [telatBulan, setTelatBulan] = useState("");
  const [nominalTerlambat, setNominalTerlambat] = useState("");
  const [adm1, setAdm1] = useState("");
  const [adm2, setAdm2] = useState("");
  const [adm3, setAdm3] = useState("");
  const [patokanHarga, setPatokanHarga] = useState("");
  const [pendapatanAdm, setPendapatanAdm] = useState("");

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let isEditableManager = user.tipeUser !== "ADMIN";
  let isEditableAdmin = true;
  let isEditable = isEditableManager || isEditableAdmin;

  useEffect(() => {
    getHitunganSimulasiById();
  }, []);

  const getHitunganSimulasiById = async () => {
    if (id) {
      const response = await postRequest(
        `/hitunganSimulasis/${idHitunganSimulasi}`,
        {},
        navigate,
        dispatch,
      );
      setNo(response.data.no);
      setTglLelang(
        response.data.tglLelang && formatDate(response.data.tglLelang),
      );
      setNominalLelang(response.data.nominalLelang.toLocaleString("de-DE"));
      setSubsidi(response.data.subsidi.toLocaleString("de-DE"));
      setAngsuran(response.data.angsuran.toLocaleString("de-DE"));
      setCadangan(response.data.cadangan.toLocaleString("de-DE"));
      setTotalPenerimaanLelang(
        response.data.totalPenerimaanLelang.toLocaleString("de-DE"),
      );
      setLelangUndi(response.data.lelangUndi.toLocaleString("de-DE"));
      setSisaPeriode(response.data.sisaPeriode.toLocaleString("de-DE"));
      setHutang(response.data.hutang.toLocaleString("de-DE"));
      setYangSudahDisetor(
        response.data.yangSudahDisetor.toLocaleString("de-DE"),
      );
      setTotalSetor(response.data.totalSetor.toLocaleString("de-DE"));
      setUangYangDiterima(
        response.data.uangYangDiterima.toLocaleString("de-DE"),
      );
      setSelisih(response.data.selisih.toLocaleString("de-DE"));
      setBunga(response.data.bunga.toLocaleString("de-DE"));
      setTelatBulan(response.data.telatBulan.toLocaleString("de-DE"));
      setNominalTerlambat(
        response.data.nominalTerlambat.toLocaleString("de-DE"),
      );
      setAdm1(response.data.adm1.toLocaleString("de-DE"));
      setAdm2(response.data.adm2.toLocaleString("de-DE"));
      setAdm3(response.data.adm3.toLocaleString("de-DE"));
      setPatokanHarga(response.data.patokanHarga.toLocaleString("de-DE"));
      setPendapatanAdm(response.data.pendapatanAdm.toLocaleString("de-DE"));
    }
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Detail Hitungan Simulasi</h5>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate(`/daftarKelompok/kelompok/${id}`)}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={deleteButtonContainer}>
        {isEditable && (
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(
                  `/daftarKelompok/kelompok/${id}/hitunganSimulasi/${idHitunganSimulasi}/edit`,
                );
              }}
            >
              Ubah
            </Button>
          </ButtonGroup>
        )}
      </Box>
      <hr />
      <Card>
        <Card.Header>Detail Hitungan Simulasi</Card.Header>
        <Card.Body>
          <Form>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        No :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={no} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Tgl. Lelang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={tglLelang} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="4" style={textRight}>
                        Nominal Lelang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={nominalLelang} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Subsidi :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={subsidi} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Angsuran :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={angsuran} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Cadangan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={cadangan} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Total Penerimaan Lelang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={totalPenerimaanLelang}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Lelang Undi :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={lelangUndi} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Sisa Periode :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={sisaPeriode} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Hutang :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={hutang} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Yang Sudah Disetor :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={yangSudahDisetor}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>

              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Total Setor :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={totalSetor} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Uang Yang Diterima :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={uangYangDiterima}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Selisih :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={selisih} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Bunga :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={bunga} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Telat Bulan :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={telatBulan} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Nominal Terlambat :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control
                          value={nominalTerlambat}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Adm 1 :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={adm1} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Adm 2 :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={adm2} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Adm 3 :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={adm3} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Patokan Harga :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={patokanHarga} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group as={Row} className="mb-3">
                      <Form.Label column sm="4" style={textRight}>
                        Pendapatan Adm :
                      </Form.Label>
                      <Col sm="8">
                        <Form.Control value={pendapatanAdm} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilHitunganSimulasi;

const deleteButtonContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
